import useCompanyBranches from "./useCompanyBranches";

export default useCompanyBranches;
